import {
  Button,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  LoadingIndicator,
  Progress,
} from '@commenda/kakashi';

interface ProcessingStepProps {
  processedRows: number;
  totalRows: number;
  progressPercent: number;
  onClose: () => void;
}

export const ProcessingStep = ({
  processedRows,
  totalRows,
  progressPercent,
  onClose,
}: ProcessingStepProps) => (
  <>
    <DialogHeader className="flex flex-col gap-xs items-start">
      <DialogTitle>Sending Messages</DialogTitle>
      <DialogDescription>
        Your messages are being sent in the background. You can wait for them to complete or close this modal.
      </DialogDescription>
    </DialogHeader>

    <div className="px-2xl py-xl flex flex-col gap-xl items-center justify-center">
      <LoadingIndicator size={48} />
      <div className="w-full flex flex-col gap-sm">
        <Progress value={progressPercent} accent="blue" />
        <p className="txt-small-medium text-text-secondary text-center">
          {processedRows} of {totalRows} messages sent
        </p>
      </div>
    </div>

    <DialogFooter>
      <Button variant="secondary" onClick={onClose} disabled>
        Close
      </Button>
    </DialogFooter>
  </>
);
